<template>
  <div class="leftbar-view elffy-dashboard" :class="{'left-aside-toggle': toggle_aside}">
    <!--Page Container Start Here-->
    <section class="main-container">
      <div class="container-fluid">
        <div class="row text-left">
          <ProjectManageBoard :user="user" :deal="deal" :project="project" @update-project="updateProject" @update-deal="updateDeal"></ProjectManageBoard>
        </div>
      </div>
    </section>
    <!-- modal template start -->
    <!-- modal template end-->
    <simplert :useRadius="true" :useIcon="true" ref="simplert">
    </simplert>
  </div>
</template>
<script>
import Simplert from 'vue2-simplert'
import dealHeader from '../Deals/DealHeader';
import { getCookie, setCookie } from '../../assets/js/elffy_js/cookie.js'
import ProjectManageBoard from '../ProjectManage/ProjectManageBoard'


export default {
  name: 'deal_management',
  data() {
    return {
      deal: '',
      
      auth_token: {},
      user_id: '',

      project: {
        project_lists: []
      },
      upperDropPlaceholderOptions: {
        className: 'cards-drop-preview',
        animationDuration: '150',
        showOnTop: true
      },
      dropPlaceholderOptions: {
        className: 'drop-preview',
        animationDuration: '150',
        showOnTop: true
      }

    }
  },
  components: {
    Simplert,dealHeader ,ProjectManageBoard
  },
  created() {
    this.deal_token = this.$route.params.deal_token
    // this.getDeal(this.deal_token)
  },
  props: ['toggle_aside','user'],
  methods: {
    updateProject(project){
      this.project = project
    },
    updateDeal(deal){
      this.deal = deal
    },
  },
  filters: {
    moment: function(date) {
      moment.locale('zh-tw');
      return moment(date).format('LLL');;
    },
  }
}
</script>


// WEBPACK FOOTER //
// DealManagement.vue?117047dc